import { render, staticRenderFns } from "./sensorForm.vue?vue&type=template&id=2864b845"
import script from "./sensorForm.vue?vue&type=script&lang=js"
export * from "./sensorForm.vue?vue&type=script&lang=js"
import style0 from "./sensorForm.vue?vue&type=style&index=0&id=2864b845&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports